export const Video = (props: { id: string }) => {
    const { id } = props;

    return (
        <div className="ratio ratio-16x9">
            <iframe
                src={`https://www.youtube-nocookie.com/embed/${id}?rel=0&enablejsapi=1`}
                allowFullScreen={true}
                title="YouTube video"
            ></iframe>
        </div>
    );
};
